import { dateFns as moment } from '@pcln/date-fns-utils'
import { get, head, last } from 'lodash'

export const MAX_STAY_LENGTH = 28

export function canShowHotelXSell(searchRequest) {
  const slices = get(searchRequest, 'slices', [])
  const startDate = head(slices)?.travelDate
  const endDate = last(slices)?.travelDate

  if (!startDate || !endDate) {
    return false
  }

  const los = moment(endDate).diff(moment(startDate), 'days')

  return los && parseInt(los) <= MAX_STAY_LENGTH
}
